const dev = {
  api: {
    BASE_URL: 'http://localhost:4000/api/v1/modquiz',
    AUTH_BASE_URL: 'http://localhost:4000/api/v1',
  },
};

const prod = {
  api: {
    BASE_URL: `${process.env.REACT_APP_LRNER_API_URL || 'https://api.lrner.io'}/api/v1/modquiz`,
    AUTH_BASE_URL: `${process.env.REACT_APP_LRNER_API_URL || 'https://api.lrner.io'}/api/v1`,
  },
};


const mobile_dev = {
  api: {
    BASE_URL: `http://${process.env.REACT_APP_API_URL}/api/v1`
  },
};


let config
if (process.env.REACT_APP_STAGE === 'production' || process.env.NODE_ENV === 'production') {
    config = prod;
} else if (process.env.REACT_APP_STAGE === 'mobile_dev') {
    config = mobile_dev
} else {
    config = dev
}



export { config, prod }
